<template>
    <div class="tabs">
        <router-link :to="{ name : 'Users' }" class="tab">Users</router-link>
        <router-link :to="{ name : 'Roles' }" class="tab">Roles</router-link>
    </div>
</template>

<script>
export default {
    name : "UsersTabs"
}
</script>

<style lang="scss" scoped>
    .tabs {
        display: flex;
        justify-content: center;
        margin-bottom:30px;
    }

    .tab {
        color:#fff;
        text-transform: uppercase;
        font-size:15px;
        padding:10px 30px;
        border-bottom:2px solid #333;
    }

    .tab:hover, .tab.router-link-exact-active {
        color:$mainColor;
        border-color:$mainColor;
    }
</style>
